import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Button } from '../../Button/Button';
import { DialogTitle } from '../../Dialog/DialogTitle/DialogTitle';
import type { DiscardConfig } from '../types';

export type DiscardChangesModalProps = Pick<DiscardConfig, 'show' | 'onConfirm' | 'onCancel' | 'title' | 'message'>;

export const DiscardChangesModal = ({ show, onConfirm, onCancel, title, message }: DiscardChangesModalProps) => {
  const { t } = useTranslation();

  const modalTitle = title ?? t('Discard Changes');
  const modalMessage = message ?? t(`You're about to lose your changes.`);

  return (
    <Dialog open={show} onClose={onCancel}>
      <DialogTitle onClose={onCancel}>{modalTitle}</DialogTitle>

      <DialogContent dividers>
        <Box>
          <Typography data-test="modal-info">{modalMessage}</Typography>
          <Typography
            sx={{
              mt: 2,
            }}
          >
            {t('Do you want to proceed?')}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button data-test="cancel-button" onClick={onCancel} variant="text">
          {t('Cancel')}
        </Button>

        <Button data-test="drop-changes-button" onClick={onConfirm} color="error">
          {t('Drop changes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
